<div class="card pad15 ">
    <ul ngbNav #nav="ngbNav" class="nav-pills subtab">
        <li *ngFor="let tab of tabs" class="nav-item">
            <a translate class="nav-link" (click)="selectedTabs=tab.id"
                [ngClass]="{'active': selectedTabs===tab.id}">{{tab.label}}</a>
        </li>
    </ul>
    
</div>
<ng-cotainer *ngIf="selectedTabs===1">
    <app-active-work-orders></app-active-work-orders>
</ng-cotainer>
<ng-cotainer *ngIf="selectedTabs===2">
    <app-historical-work-orders></app-historical-work-orders>
</ng-cotainer>